<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="ecs-quick-crm-contact-info">
    <div v-show="fieldsToDisplay.length" class="section-title">{{ $t('interactionDetails') }}</div>
    <div class="grid">
      <div v-for="field in fieldsToDisplay" :key="field.key" class="field">
        <div class="content">
          <div v-once class="prop-label">{{ field.label }}</div>
          <div class="prop-value">{{ field.value }}</div>
        </div>
        <div class="actions">
          <v-tooltip top z-index="9999">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="copyToClipboard(field.label, field.value)">
                <v-icon> mdi-content-copy </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('copy', { fieldName: field.label }) }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EcsQuickInteractionDetails',

  components: {},

  props: {
    businessProcessId: {
      type: String,
      required: true
    },
    interactionVariables: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      fieldsToDisplay: []
    };
  },

  computed: {
    ...mapGetters('ORGANIZATION', ['getInteractionDetailsDisplayTemplateForBP']),

    template() {
      return this.getInteractionDetailsDisplayTemplateForBP(this.businessProcessId);
    }
  },

  watch: {
    template: {
      immediate: true,
      handler() {
        if (!this.template) {
          this.fieldsToDisplay = [];
          return;
        }

        this.fieldsToDisplay = this.template.fields
          .sort((fieldA, fieldB) => fieldA.order - fieldB.order)
          .map(field => ({
            key: field.interactionVariableName,
            label: field.displayName,
            format: field.format,
            value: this.getInteractionVariableValue(field.interactionVariableName, field.format)
          }));
      }
    }
  },

  methods: {
    getInteractionVariableValue(variableName, format) {
      const variable = this.interactionVariables.find(variable => variable && variable.name === variableName);
      return variable && variable.value && this.format(variable.value, format);
    },

    format(value, format) {
      switch (format) {
        case 'string':
        case 'text':
        case 'number':
          return value || '';
        case 'date':
          return this.fromNow(value, 'UTC', true);
        case 'duration':
          return this.kpiFormat(value, 'duration', true);
        default:
          return value;
      }
    },

    copyToClipboard(label, value) {
      navigator.clipboard
        .writeText(value || '')
        .then(() => {
          this.$root.$emit('snackbar-message', {
            message: this.$t('copySuccess', { label }),
            type: 'success'
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped src="./scoped.scss" lang="scss" />
